import { InjectionToken } from '@angular/core';

import {
  ILanguageMenuI18nService,
  ILanguageMenuLang,
} from '../interfaces/language-menu.interfaces';

export const LANGUAGE_MENU_I18N_SERVICE = new InjectionToken<ILanguageMenuI18nService>(
  'LANGUAGE_MENU_I18N_SERVICE',
);

export const LANGUAGE_MENU_LANG_LIST = new InjectionToken<ReadonlyArray<ILanguageMenuLang>>(
  'LANGUAGE_MENU_LANG_LIST',
);
